import { IPlainObject } from "lobbie";
import { FiCheck, FiX } from "react-icons/fi";
import { LOBBIE_COLORS } from "src/utils/colors";
interface IProps {
    src: string;
    alt?: any;
    style?: IPlainObject;
    containerStyle?: IPlainObject;
    onError?: () => void;
}

export const InvisibleX = () => <FiX className="invisible" />;
export const SelectedCheck = () => (
    <FiCheck style={{ backgroundColor: "transparent", color: LOBBIE_COLORS.white }} />
);

const Avatar: React.FC<IProps> = ({ alt, style, containerStyle, src, onError }) => {
    const customContainerStyle = containerStyle ? containerStyle : {};
    const customStyle = style ? style : {};

    const Alt = alt && typeof alt !== "string" ? alt : null;

    if (!src) {
        return (
            <div className="rounded-circle text-center" style={customContainerStyle}>
                <div style={customStyle}>{alt && typeof alt === "string" ? alt : <Alt />}</div>
            </div>
        );
    }

    return (
        <div style={customContainerStyle}>
            <img
                className="rounded-circle"
                src={src}
                alt={alt || "avatar"}
                style={customStyle}
                onError={onError ? onError : undefined}
            />
        </div>
    );
};

export default Avatar;

export const NotSelectedAvatar = () => (
    <Avatar
        containerStyle={{
            backgroundColor: LOBBIE_COLORS.secondary,
        }}
        src={""}
        alt={InvisibleX}
    />
);

export const SelectedAvatar = () => (
    <Avatar
        containerStyle={{
            backgroundColor: LOBBIE_COLORS.primary,
        }}
        src={""}
        alt={SelectedCheck}
    />
);
